module.exports = __webpack_public_path__ + "static/img/logo.c3c5c52e.svg";